import { useCallback } from 'react';
import { prop } from 'ramda';
import * as urlUtil from 'js/utils/url.util';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { storageService } from 'js/services/storage.service';

export const useNavigateFromLaunchGamePath = () => {
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const navigateWithReplace = useNavigate({ replace: true });
    const { pathname } = location;
    const { prevPath } = location.state as { prevPath: string } || {};

    return useCallback(() => {
        if (urlUtil.isLaunchGamePath(pathname)) {
            const gamesPageUrl = storageService.session.getItem('gamesPageUrl');

            storageService.session.removeItem('gamesPageUrl');

            navigateWithReplace(gamesPageUrl || prevPath || rootPage);
        }
    }, [prevPath, rootPage, navigateWithReplace, pathname]);
};
